import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { formatGregorianDateFromDateParts } from '../../../../../../helpers/collaborativeIndexations'
import { isEmpty } from '../../../../../../helpers/sanityChecks'
import Unspecified from "../Unspecified"

class Gregorian extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        value: PropTypes.object.isRequired,
    }

    render()
    {
        if(isEmpty(this.props.value.parts.year))
        {
            return <Unspecified/>
        }

        const gregorianDate = formatGregorianDateFromDateParts(this.props.value.parts, this.props.t)

        return (
            <span title={ gregorianDate }>
                { gregorianDate }
            </span>
        )
    }
}

export default withTranslation()(Gregorian)
